"use client";

import { sendEvent } from "@/lib/utils/analytics";
import { type TouchpointType } from "@/lib/quiz-attribution";

interface StickyFooterCtaProps {
  onCtaClick: () => void;
  touchpointType?: TouchpointType;
}

export default function StickyFooterCta({ onCtaClick, touchpointType }: StickyFooterCtaProps) {
  return (
    <div className="w-full fixed bottom-0 left-1/2 -translate-x-1/2 bg-white flex items-center p-4 justify-center z-[2] shrink-0 outline outline-1 outline-white">
      <button
        className="flex w-full py-3 px-[30px] justify-center items-center self-stretch rounded-lg bg-[#232221] text-white text-center title-16 border-none cursor-pointer transition-colors duration-300"
        data-testid="sticky-footer-cta"
        onClick={() => {
          sendEvent("track_hormones_clicked", {
            quiz_source: "bottom_sheet",
            touchpoint_type: touchpointType,
          });
          onCtaClick();
        }}
      >
        Track my hormones
      </button>
    </div>
  );
}
